/** Parse a "YYYY-MM-DD" date + "HH:MM[:SS]" time into a LOCAL wall-clock Date. Lobby-day meeting
 *  times are wall-clock values with no zone, so they are interpreted in the device's local time. */
export function localDateTime(datePart: string, timePart: string): Date {
  const [y, mo, d] = datePart.split('-').map(Number)
  const [h, mi] = timePart.split(':').map(Number)
  return new Date(y, mo - 1, d, h, mi, 0)
}
